export const routes = {
  root:          '/',
  dashboard:     '/dashboard',
  transactions:  '/transactions',
  correlations:  '/trades',
  bySymbols:     '/symbol-structure',
  byTime:        '/time-structure',
  calendar:      '/calendar',
  pnl:           '/pnl',
  timeInTrade:   '/time-of-trade',
  settings:      '/settings',
  login:         '/login',
  register:      '/register',
  verifyEmail:   '/verify-email',
  forgotPassword:'/forgot-password',
  newPassword:   '/new-password',
  authCallback:  '/auth/callback',
  signedOut:     '/signed-out',
  terms:         '/terms',
  backtesting:   '/backtesting',
  upgrade:       '/upgrade',
  billingSuccess:'/billing/success',
  // `Stripe:CreditPack:SuccessUrl` — the credit-pack checkout's return page (2026-08-14). A distinct
  // path from `billingSuccess` because it waits on a different thing (a credit balance going up,
  // not an entitlement flipping) and returns to backtesting rather than the dashboard.
  creditsSuccess:'/billing/credits/success',
} as const;

export type RouteKey = keyof typeof routes;

/**
 * The Journal has had NO in-app privacy policy page since 2026-08-21 (user decision): the
 * self-authored `/privacy` document was retired without ever going through counsel, and every
 * "Privacy Policy" link now targets the Optimus Futures main-site policy instead. `/privacy` itself
 * falls through the router's catch-all so the old copy is not publicly exposed on the domain.
 * External — always render as `<a target="_blank" rel="noreferrer">`, never `<Link>`.
 *
 * The COOKIE policy went the same way on 2026-08-24, but with NO replacement URL yet: `/cookies`
 * is unrouted and every "Cookie Policy" mention renders as DISABLED text (see ConsentBanner /
 * PrivacyDataSection). ⏰ REMINDER (user: "remind me about it on a later stage"): a cookie policy
 * must come back — either a main-site URL like the privacy one, or a restored in-app page
 * (CookiePolicyPage lives in git history, deleted 2026-08-24 on main).
 */
export const PRIVACY_POLICY_URL = 'https://optimusfutures.com/PrivacyPolicy.php';
